// src/utils/semver.ts
var SEMVER_RE = /^(\d+)\.(\d+)\.(\d+)$/;
function isValidSemver(version) {
  return SEMVER_RE.test(version);
}
function parseSemver(version) {
  const match = version.match(SEMVER_RE);
  if (!match) {
    throw new Error(
      `Invalid semver: "${version}". Expected format: major.minor.patch`
    );
  }
  return {
    major: Number(match[1]),
    minor: Number(match[2]),
    patch: Number(match[3])
  };
}
function compareSemver(a, b) {
  const pa = parseSemver(a);
  const pb = parseSemver(b);
  return pa.major - pb.major || pa.minor - pb.minor || pa.patch - pb.patch;
}
function latestVersion(versions) {
  if (versions.length === 0) {
    throw new Error("Cannot determine latest version from empty array");
  }
  return versions.reduce(
    (latest, v) => compareSemver(v, latest) > 0 ? v : latest
  );
}

export {
  isValidSemver,
  parseSemver,
  compareSemver,
  latestVersion
};
//# sourceMappingURL=chunk-244MHDOZ.js.map